import { useLazyGetRoomSessionsForFilterQuery } from '../../apps/professional-app/fa/store/fa'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { selectLiveMeetingsPollingEnabled, setLiveMeetings, setLiveMeetingsLoading } from '../../store/liveMeetings/liveMeetings'
import { useCallback, useEffect } from 'react'
import { usePollingEffect } from '../../apps/professional-app/fa/common/hooks/usePollingEffect'
import { selectLiveMeetingsCompositeFilter } from '../../store/sessionFilter/sessionFilter'
import { selectAccountId } from '../../store/auth/authSlice'

export const LiveMeetingsPoller: React.FC = () => {
  const accountId = useAppSelector(selectAccountId)

  usePollLiveMeetings(accountId)
  return null
}

const usePollLiveMeetings = (accountId: string) => {
  const dispatch = useAppDispatch()
  const [triggerGetRoomSessions] = useLazyGetRoomSessionsForFilterQuery()
  const liveMeetingsPollingEnabled = useAppSelector(selectLiveMeetingsPollingEnabled)
  const compositeFilter = useAppSelector(selectLiveMeetingsCompositeFilter)

  const getLiveMeetings = useCallback(async () => {
    dispatch(setLiveMeetingsLoading(true))
    try {
      const { data: liveMeetings } = await triggerGetRoomSessions({ accountId, filter: compositeFilter, pageRequest: { page: 0, size: 500 } }).unwrap()
      dispatch(setLiveMeetings(liveMeetings))
    } finally {
      dispatch(setLiveMeetingsLoading(false))
    }
  }, [triggerGetRoomSessions, accountId, compositeFilter, dispatch])

  const { start: startLiveMeetingsPolling, stop: stopLiveMeetingsPolling } = usePollingEffect(getLiveMeetings, [compositeFilter], {
    interval: 30000,
  })

  useEffect(() => {
    if (liveMeetingsPollingEnabled) {
      startLiveMeetingsPolling()
    } else {
      stopLiveMeetingsPolling()
    }
  }, [liveMeetingsPollingEnabled, startLiveMeetingsPolling, stopLiveMeetingsPolling])
}
